module.exports = __webpack_public_path__ + "img/alll1.f0065f88.jpg";